import { Icon } from '../../../layout/Icon.jsx';
import { Card } from '../../../layout/Card.jsx';
import { PurchaseRow } from './PurchaseRow.jsx';

export function PurchasesList({
  invoices = [],
  loading,
  page,
  pages,
  total,
  mode = 'page',
  notice = '',
  onPageChange,
  canEdit,
  canPost,
  onPost,
  onCancel,
  onDelete
}) {
  const showAll = mode === 'all';
  return (
    <Card>
      {notice ? (
        <div className="card p-2.5 mb-2 text-[12.5px]" style={{ background: '#FFF7ED', borderColor: '#FED7AA' }}>
          ⚠️ {notice}
        </div>
      ) : null}
      <div className={showAll ? 'overflow-auto' : 'overflow-x-auto'} style={showAll ? { maxHeight: '65vh' } : undefined}>
        <table className="w-full text-[13px]">
          <thead className="text-ink-2 text-[12px] sticky top-0 bg-white">
            <tr className="border-b border-line">
              <th className="p-2.5 text-start">رقم الفاتورة</th>
              <th className="p-2.5 text-start">المورد</th>
              <th className="p-2.5 text-start">المخزن</th>
              <th className="p-2.5 text-start">التاريخ</th>
              <th className="p-2.5 text-start">الأصناف</th>
              <th className="p-2.5 text-start">الإجمالي</th>
              <th className="p-2.5 text-start">المدفوع</th>
              <th className="p-2.5 text-start">المتبقي</th>
              <th className="p-2.5 text-start">الحالة</th>
              <th className="p-2.5 text-end">إجراءات</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={10} className="text-center text-ink-3 py-8">جاري التحميل...</td></tr>
            ) : invoices.length === 0 ? (
              <tr><td colSpan={10} className="text-center text-ink-3 py-10">لا توجد فواتير</td></tr>
            ) : (
              invoices.map((inv) => (
                <PurchaseRow
                  key={inv._id || inv.id}
                  invoice={inv}
                  canEdit={canEdit}
                  canPost={canPost}
                  onPost={onPost}
                  onCancel={onCancel}
                  onDelete={onDelete}
                />
              ))
            )}
          </tbody>
        </table>
      </div>
      {showAll ? (
        <div className="card-h border-b-0 border-t flex justify-between items-center text-[12px]">
          <div className="text-ink-3">يُعرض {invoices.length} من {total} فاتورة — قائمة واحدة بلا ترقيم</div>
        </div>
      ) : pages > 1 ? (
        <div className="card-h border-b-0 border-t flex justify-between items-center text-[12px]">
          <div className="text-ink-3">صفحة {page} من {pages} • {total} فاتورة</div>
          <div className="flex gap-1">
            <button
              type="button"
              className="btn"
              style={{ padding: '6px 10px' }}
              onClick={() => onPageChange(page - 1)}
              disabled={page <= 1}
            >
              <Icon name="chevronR" size={13} />
            </button>
            <button
              type="button"
              className="btn"
              style={{ padding: '6px 10px' }}
              onClick={() => onPageChange(page + 1)}
              disabled={page >= pages}
            >
              <Icon name="chevronL" size={13} />
            </button>
          </div>
        </div>
      ) : null}
    </Card>
  );
}
